import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
  faSearch,
  faDownload
} from '@fortawesome/fontawesome-free-solid'
import { BASE_URL } from '../../config'
import Api from '../../services/api'

class LotDeliveryDocuments extends Component {
  async openDocLink(doc) {
    try {
      const res = await Api.getSignedUrl(doc.key);

      if (!res?.url) return '';

      // ✅ Always return direct signed URL
      return res.url;

    } catch (err) {
      console.error('Failed to get document URL:', err);
      return '';
    }
  }
  render() {
    if (!this.props.documents.length) {
      return (
        <div className='lot-documents'>
          <div className='row'>
            <div className='row-title-wrap'>
              <p className='row-title'>Documents</p>
            </div>
            <div className='documents-container'>
              <div className='empty-documents-wrapper'>
                <span className='text'>
                  No Documents
                </span>
                <span>
                  -
                </span>
              </div>

            </div>
          </div>
        </div>
      )
    }
    return (
      <div className='lot-documents'>
        <div className='row'>
          <div className='row-title-wrap'>
            <p className='row-title'>{this.props.title}</p>
          </div>
          <div className='documents-container' style={{ borderTop: 'none', borderRight: 'none', borderLeft: 'none' }}>
            {this.props.documents.map((doc, i) => {
              return (
                <div className='option' key={doc.key}>
                  <div className='file-wrap'>
                    <p className='description'>{doc.description}</p>
                    <a
                      className='view-link'
                      href='#'
                      onClick={async (e) => {
                        e.preventDefault();
                        const url = await this.openDocLink(doc);
                        if (url) window.open(url, '_blank');
                      }}
                    >
                      <span>View </span>
                      <FontAwesomeIcon icon={faSearch} />
                    </a>
                    <a className='download-link' download target='_blank' href={`${BASE_URL}download-file/${doc.key}?fileName=${doc.name}`} rel='noopener noreferrer'>
                      <span>Download</span>
                      <FontAwesomeIcon icon={faDownload} />
                    </a>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

LotDeliveryDocuments.propTypes = {
  documents: PropTypes.array.isRequired
}
LotDeliveryDocuments.defaultProps = {
  documents: []
}

export default LotDeliveryDocuments
